import React from 'react';

import BVInputSearch from '../../../BVControls/BVInputSearch/bv-input-search';

interface IBVSearch {
    className?: string;
    label?: string;
    properties: any;
}

const BVSearch: React.FunctionComponent<IBVSearch> = ({ className, label, properties }) => (
    <BVInputSearch className={className} label={label} properties={properties} />
);

export default BVSearch;